module.exports = __webpack_public_path__ + "media/images/emoticons/nine-7c1a4a7be1b48c6fff5465efb86af9eb.gif";